module.exports = __webpack_public_path__ + "static/img/sealabc-banner.99641c96.png";